import React from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import BlockIcon from '@material-ui/icons/Block'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import MyTableRow from '../../common/TableRow'
import MyTableCell from '../../common/CustomTableCell'

const headers = require('../../../assets/files/headers.json').centers_table

const crudColors = require('../../../assets/files/env.json').theme.colors.crud
const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	body: {
		fontSize: 14,
	},
}))(TableCell)

const StyledTableRow = withStyles((theme) => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
		borderBottom: '2px solid #c4ddec',
	},
}))(TableRow)

const useStyles = makeStyles({
	table: {
		minWidth: 700,
	},
})

function CustomizedTables(props) {
	const classes = useStyles()
	let numbering = 0
	let prop = props
	return (
		<TableContainer component={Paper}>
			<Table
				size="small"
				className={classes.table}
				aria-label="customized table"
			>
				<TableHead>
					<MyTableRow header={headers}></MyTableRow>
				</TableHead>
				<TableBody>
					{props?.data?.map(function (item, index) {
						numbering++
						return (
							<StyledTableRow key={index}>
								<MyTableCell
									key={'centers_numbering' + index}
									value={item?.id}
								></MyTableCell>

								<MyTableCell
									key={'centers_name' + item.id}
									value={item.name}
								></MyTableCell>
								<MyTableCell
									key={'centers_dep_name' + item.id}
									value={item.department.name}
								></MyTableCell>

								<MyTableCell
									key={'centers_order' + item.id}
									value={item.order}
								></MyTableCell>
								<MyTableCell
									key={'centers_descr' + item.id}
									value={item.descr}
								></MyTableCell>
								<MyTableCell
									key={'centers_manager_name' + item.id}
									value={item.manager}
								></MyTableCell>
								<MyTableCell
									key={'centers_job_title' + item.id}
									value={item.job_title}
								></MyTableCell>
								<MyTableCell
									key={'centers_creator' + item.id}
									value={item.user.name}
								></MyTableCell>
								<MyTableCell
									key={'centers_total_veh_count' + item.id}
									value={item.stats.total_vehicles_count}
								></MyTableCell>
								<StyledTableCell key={'center_active' + item.id} align="right">
									<IconButton
										onClick={() =>
											prop.activeChange({
												center: item,
												index: index,
											})
										}
									>
										{item.is_enabled === '1' || item.is_enabled === 1 ? (
											<CheckCircleIcon style={{ color: crudColors.u }} />
										) : (
											<BlockIcon style={{ color: 'red' }} />
										)}
									</IconButton>
								</StyledTableCell>
								<StyledTableCell key={'center_edit' + item.id} align="right">
									<IconButton
										onClick={() =>
											prop.showEditModalFun({
												center: item,
												index: index,
											})
										}
									>
										<EditIcon style={{ color: crudColors.u }} />
									</IconButton>
								</StyledTableCell>
								<StyledTableCell key={'center_delete' + item.id} align="right">
									<IconButton
										onClick={() =>
											prop.showDeleteModalFun({
												center: item,
												index: index,
											})
										}
									>
										<DeleteForeverIcon style={{ color: crudColors.d }} />
									</IconButton>
								</StyledTableCell>
							</StyledTableRow>
						)
					})}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

export default CustomizedTables
